import React from 'react';
import { ToastContainer } from 'react-toastify';

// @see src/scss/core for the usuage of the toastify css

export default function AlertError() {
  return (
    <ToastContainer
      position="bottom-right"
      autoClose={3000}
      hideProgressBar
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnVisibilityChange
      draggable
      pauseOnHover
    />
  );
}



// WEBPACK FOOTER //
// ./src/components/ErrorMessage/AlertError.js